import {
  PhxButtonModule,
  PhxIconButtonModule,
  PhxIconModule,
  PhxModalModule,
  PhxTooltipModule,
} from 'phx-core';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExpansionUpsellsBannerComponent } from './upsells/banner-upsell/expansion-upsell-banner.component';
import { ExpansionUpsellsCompanyUpsellComponent } from './upsells/company-page-upsell/company-upsell.component';
import { ExpansionUpsellsFloatingUpsellComponent } from './upsells/floating-upsell/floating-upsell.component';
import { ExpansionUpsellsSidebarUpsellComponent } from './upsells/sidebar-upsell/sidebar-upsell.component';
import { ExpansionUpsellsUpsellModalComponent } from './upsells/upsell-modal/upsell-modal.component';

const COMPONENTS = [
  ExpansionUpsellsBannerComponent,
  ExpansionUpsellsCompanyUpsellComponent,
  ExpansionUpsellsFloatingUpsellComponent,
  ExpansionUpsellsSidebarUpsellComponent,
  ExpansionUpsellsUpsellModalComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  imports: [
    CommonModule,
    PhxButtonModule,
    PhxIconButtonModule,
    PhxModalModule,
    PhxIconModule,
    PhxTooltipModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExpansionUpsellsModule {}